import './authenticatedLayout.scss'
import { Outlet } from 'react-router-dom'
import { JSX, useEffect, useRef, useState } from 'react'
import { TopNavigationHeader } from '@shared/components/webviewHeader/topNavigationHeader'
import { Header } from 'components'

export function AuthenticatedLayout(): JSX.Element {
  const headerContainer = useRef<HTMLDivElement>(null)
  const spacer = useRef<HTMLDivElement>(null)
  const [size, setSize] = useState<number | null>(null)

  useEffect(() => {
    const headerElem = headerContainer?.current
    if (!headerElem) return

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setSize(entry?.contentRect?.height)
      }
    })

    resizeObserver.observe(headerElem)

    return () => {
      resizeObserver.unobserve(headerElem)
      resizeObserver.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <main>
      <Header />
      <div className='top-header-container'>
        <div className='top-header-container__header' ref={headerContainer}>
          <TopNavigationHeader />
        </div>
        <div
          className='top-header-container__spacer'
          ref={spacer}
          style={{
            height: size,
          }}
        ></div>
      </div>
      <div className='container'>
        <Outlet />
      </div>
    </main>
  )
}
